import { baseName, getElementIndex, toArray } from './helpers'

/**
 * Intersection Observer
 */
const observedElements = new Map()

const observer = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		const callback = observedElements.get(entry.target)
		if (callback) {
			callback(entry)
		}
	})
})

function observeWithCallback(element, callback) {
	observedElements.set(element, callback)
	observer.observe(element)
}

/**
 * Track Hero Slider
 *
 * This is an export because it needs to be called from the `ready` event of the
 * flickity instance.
 */
export function trackHeroSlider(heroSlider) {
  function trackCell(event) {
    // Check if we are on homepage
    if (!drupalSettings.path.isFront) return

		const type = event?.type === 'click' ? 'click' : 'view'

		const cell = heroSlider.selectedElement
		const cellIndex = heroSlider.selectedIndex
		const cellId = cell.querySelector('img, video source').getAttribute('src')
		const cellName = cell.querySelector('h2')?.textContent.trim()

		window.dataLayer.push({
			event: [type === 'click' ? 'promoClick' : 'promoImpression'],
			ecommerce: {
				[type === 'click' ? 'promoClick' : 'promoView']: {
					promotions: [
						{
							id: baseName(cellId),
							name: cellName,
							creative: 'Marcom',
							position: cellIndex
						}
					]
				}
			}
		})
	}

	// track view
	observeWithCallback(heroSlider.element, entry => {
		if (entry.isIntersecting) {
			trackCell()
			heroSlider.on('change', trackCell)
		} else {
			heroSlider.off('change', trackCell)
		}
	})

	// track click
	heroSlider.cells.forEach(cell => {
		const link = cell.element.querySelector('a[href]')
		if (link) {
			link.addEventListener('click', trackCell)
		}
	})
}

/**
 * Intersection Observer for Knowledge Teasers
 */
const knowledgeTeaserObserver = new IntersectionObserver(entries => {
	const intersectingEntries = entries.filter(entry => entry.isIntersecting)
	if (intersectingEntries.length) {
		trackTeaser(intersectingEntries.map(entry => entry.target))
	}
})

/**
 * Track Knowledge Teaser
 */
function trackTeaser(target, type = 'view') {
	target = toArray(target)

	window.dataLayer.push({
		event: [type === 'click' ? 'promoClick' : 'promoImpression'],
		ecommerce: {
			[type === 'click' ? 'promoClick' : 'promoView']: {
				promotions: target.map(teaser => {
					const teaserIndex = getElementIndex(teaser)
					const teaserId = teaser.querySelector('img, video source').getAttribute('src')
					const teaserName = teaser.textContent.trim()

					return {
						id: baseName(teaserId),
						name: teaserName,
						creative: 'Wissen',
						position: teaserIndex
					}
				})
			}
		}
	})
}

function trackKnowledgeTeaser(teaser) {
	// track view
	knowledgeTeaserObserver.observe(teaser)

	// track click
	const link = teaser.querySelector('a[href]')
	if (link) {
		link.addEventListener('click', trackTeaser.bind(null, teaser, 'click'))
	}
}

/**
 * Tracking component default exoprt
 */
const Tracking = function () {
	window.dataLayer = window.dataLayer || { push: console.log }

  function init() {
    // Check if we are on homepage
    if (!drupalSettings.path.isFront) return

		const knowledgeTeaser = document.querySelectorAll('.center.none.section.cards .box-3.center.bg-offwhite.img-card')
		knowledgeTeaser.forEach(trackKnowledgeTeaser)
	}

	return {
		init
	}
}()

export default Tracking
